import React from 'react';

const ProfileMentoringListing = ({ data, onEdit, onDelete, isLoading }) => {
    const formatMonthYear = (val) => {
        if (!val) return '---';
        const parts = val.split('-');
        if (parts.length === 2) return `${parts[1]}/${parts[0]}`;
        return val;
    };

    return (
        <div className="table-card">
            {isLoading ? (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <i className="fa-solid fa-circle-notch fa-spin" style={{ marginRight: '8px' }}></i>
                    Đang tải dữ liệu
                </div>
            ) : data.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '60px 20px', color: '#666' }}>
                    <i className="fa-solid fa-users" style={{ fontSize: '60px', color: '#5dade2', marginBottom: '15px' }}></i>
                    <h3 style={{ color: '#e74c3c', margin: '0 0 10px 0' }}>Chưa có dữ liệu hướng dẫn học viên</h3>
                </div>
            ) : (
                <div style={{ overflowX: 'auto', width: '100%' }}>
                    <table className="custom-table" style={{ width: '100%', minWidth: '1000px' }}>
                        <thead>
                            <tr>
                                <th width="5%" style={{ textAlign: 'center' }}>STT</th>
                                <th width="15%">HỌC VIÊN</th>
                                <th width="10%">TRÌNH ĐỘ</th>
                                <th width="30%">ĐỀ TÀI</th>
                                <th width="20%">TRƯỜNG</th>
                                <th width="10%" style={{ textAlign: 'center' }}>NĂM HƯỚNG DẪN</th>
                                <th width="10%" style={{ textAlign: 'center' }}>CHỨC NĂNG</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, index) => (
                                <tr key={item.Id}>
                                    <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                    <td style={{ fontWeight: '500', color: '#2c3e50' }}>{item.StudentName}</td>
                                    <td>{item.EducationLevel}</td>
                                    <td>{item.TopicName}</td>
                                    <td>{item.SchoolName}</td>
                                    <td style={{ textAlign: 'center' }}>
                                        {formatMonthYear(item.StartYear)} <br />
                                        <span style={{ fontSize: '12px', color: '#888' }}>(Tốt nghiệp: {formatMonthYear(item.GraduationYear)})</span>
                                    </td>
                                    <td>
                                        <div className="action-group" style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                            <div className="icon-wrapper edit-wrapper" onClick={() => onEdit(item)} title="Sửa" style={{ cursor: 'pointer' }}>
                                                <i className="fa-solid fa-pen edit-icon"></i>
                                            </div>
                                            <div className="icon-wrapper delete-wrapper" onClick={() => onDelete(item.Id)} title="Xóa" style={{ cursor: 'pointer' }}>
                                                <i className="fa-solid fa-trash delete-icon"></i>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default ProfileMentoringListing;